export enum AutoOrderState {
    NotTriggered = 0,
    Triggered = 1,
    Failed = 2,
    Sent = 3,
}
